// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

//get TotalInvoiceToClient
export const TotalInvoiceToClient = createAsyncThunk('dashboardSlice/TotalInvoiceToClient', async () => {
    try {
        let response = await axios.get('/Dashboard/totalinvoice-to-clinet', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

//get OutwardBasePayment
export const OutwardBasePayment = createAsyncThunk('dashboardSlice/OutwardBasePayment', async () => {
    try {
        let response = await axios.get('/Dashboard/invoice-base-total', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

//get OutwardPayment
export const OutwardPayment = createAsyncThunk('dashboardSlice/OutwardPayment', async () => {
    try {
        let response = await axios.get('/Dashboard/invoice-final-total', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

//get InvoiceToClient
export const InvoiceToClient = createAsyncThunk('dashboardSlice/InvoiceToClient', async () => {
    try {
        let response = await axios.get('/Dashboard/invoice-to-client', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState: {
        TotalInvoiceToClient: [],
        OutwardBasePaymentInfo: {},
        OutwardPaymentInfo: {},
        InvoiceToClientData: []
    },
    extraReducers: (builder) => {
        builder.addCase(TotalInvoiceToClient.fulfilled, (state, action) => {
            state.TotalInvoiceToClient = action?.payload;
            return;
        });
        builder.addCase(OutwardBasePayment.fulfilled, (state, action) => {
            state.OutwardBasePaymentInfo = action?.payload;
            return;
        });
        builder.addCase(OutwardPayment.fulfilled, (state, action) => {
            state.OutwardPaymentInfo = action?.payload;
            return;
        });
        builder.addCase(InvoiceToClient.fulfilled, (state, action) => {
            state.InvoiceToClientData = action?.payload;
            return;
        });
    }
});

export default dashboardSlice.reducer;
